import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import CartDrawer from '@/components/feature/CartDrawer';
import CartFloatingButton from '@/components/feature/CartFloatingButton';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoriesSection from './components/CategoriesSection';
import CatalogSection from './components/CatalogSection';
import FinalCTASection from './components/FinalCTASection';
import ContactSection from './components/ContactSection';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null;
    if (!state?.scrollTo) return;

    // limpa o state pra não re-disparar em re-renders
    window.history.replaceState({}, document.title);

    if (state.scrollTo === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // aguarda o DOM da home estar pronto
    const tryScroll = (attempts: number) => {
      const el = document.getElementById(state.scrollTo!);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (attempts < 10) {
        requestAnimationFrame(() => tryScroll(attempts + 1));
      }
    };
    requestAnimationFrame(() => tryScroll(0));
  }, [location]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoriesSection />
        <CatalogSection />
        <FinalCTASection />
        <ContactSection />
      </main>
      <Footer />
      <CartDrawer />
      <CartFloatingButton />
    </div>
  );
}

export default HomePage;